export default __webpack_public_path__ + "img/gear-fill.dc370e40.svg";